import { BrowserRouter as Router} from "react-router-dom";
import { AuthProvider } from "../contexts/AuthContext";
import AnimatedRoutes from "./AnimatedRoutes";


function App() {

  return (
    <AuthProvider>
      <Router>
        <AnimatedRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
